export const APP_PATH = {
	Main: '/',
	Produtos: '/produtos',
};
